<script setup lang="ts">
import GameTable from "@/components/game/GameTable.vue";
import { useTeamStore } from "@/stores/teams.ts";
import { ref } from "vue";

const teamStore = useTeamStore();
const currentTeam = ref<string | null>(null);

function selectTeam(teamId: string) {
  if (currentTeam.value === teamId) {
    currentTeam.value = null;
    return;
  }
  currentTeam.value = teamId;
}
</script>

<template>
  <div class="page">
    <div class="panel">
      <div class="team-highlight">
        <div
          v-for="team in teamStore.teams"
          :key="team.id"
          class="team-item"
          :class="{ selected: currentTeam === team.id }"
          :style="{ backgroundImage: `url(${team.logo_url})` }"
          @click="selectTeam(team.id)"
        />
      </div>
      <GameTable
        :filter-team-id="currentTeam ?? undefined"
      />
    </div>
  </div>
</template>

<style scoped>
.team-highlight {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.team-item {
  width: 3rem;
  height: 3rem;
  background-color: white;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s linear, border-color 0.2s linear;
  border: 0.25rem solid transparent;
}

.team-item.selected {
  border-color: var(--main-color);
}

.team-item.selected,
.team-item:hover {
  transform: scale(1.1);
}
</style>
